module.exports = ".panel-heading {\r\n    background: #ccc !important;\r\n}"